import type {ReactElement} from 'react';
import {createPortal} from 'react-dom';
import {PageControlBar} from '@Components/poster-editor/components/page-control-bar/page-control-bar';
import {Page} from '@PosterWhiteboard/page/page.class';
import {useAppSelector} from '@/hooks';
import {PageSlider} from '@Components/poster-editor/components/page-slider/page-slider';

export function PageOptions(): ReactElement<any> {
  const pageOrder = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages?.pageOrder;
  });

  const renderPageTopBar = (): null | ReactElement<any>[] => {
    const pageTopBars = [];

    if (!pageOrder) {
      return null;
    }

    for (const pageId of pageOrder) {
      const container = Page.getPageRightSideHtmlContainerForPageId(pageId);
      const sliderContainer = Page.getPageBottomHtmlContainerForPageId(pageId);
      if (container) {
        pageTopBars.push(createPortal(<PageControlBar key={`control-${pageId}`} pageId={pageId} />, container));
      }

      if (sliderContainer) {
        pageTopBars.push(createPortal(<PageSlider key={`slider-${pageId}`} pageId={pageId} />, sliderContainer));
      }
    }

    return pageTopBars;
  };

  return <>{renderPageTopBar()}</>;
}
